import { Component, inject } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {Company, User} from '../../models';
import {FormUtil} from '../../utils';
import {CompanyService, TrackingService} from '../../services';

@Component({
    selector: 'app-create-project-modal',
    templateUrl: './create-update-tender-manager-modal.component.html',
    styleUrls: ['./create-update-tender-manager-modal.component.scss'],
    standalone: false
})
export class CreateUpdateTenderManagerModalComponent {
    public modalRef = inject(VwuiModalRef);
    public modalConfig = inject<VwuiModalConfig<{ title: string; data?: User; saveText: string; }>>(VwuiModalConfig);
    private companyService = inject(CompanyService);
    private trackingService = inject(TrackingService);


    public form: UntypedFormGroup;
    public loading = false;

    public title: string;
    public saveText: string;
    public user?: User = null;
    public companies: Company[];
    public selectedCompanyNames: string[];
    public availableCompanyNames: string[];

    constructor() {
        const modalConfig = this.modalConfig;

        this.title = modalConfig.data.title;
        this.saveText = modalConfig.data.saveText;
        this.user = modalConfig.data.data;

        const userValue = this.user ? {name: this.user.fullName, emailAddress: this.user.uniqueName } : null;
        this.selectedCompanyNames = this.user ? this.user.manageableCompanies.map((item) => item.name) : [];
        this.form = new UntypedFormGroup({
            user: new UntypedFormControl({value: userValue, disabled: userValue !== null},[Validators.required]),
            selectedCompanyNames: new UntypedFormControl(this.selectedCompanyNames)
        });
        this.companyService.getCompanies().then((companies) => {
            this.companies = companies;
            this.availableCompanyNames = companies.map((item) => item.name);
        });
    }

    async submit() {
        try {
            FormUtil.validate(this.form);

            if (this.form.valid) {
                const updatedValues = {...this.user};

                if (this.form.value.user) {
                    updatedValues.uniqueName = this.form.value.user.emailAddress;
                    if (updatedValues.uniqueName !== this.form.value.user.name) {
                        updatedValues.fullName = this.form.value.user.name;
                    }
                }

                const selectedItems: string[] = this.form.value.selectedCompanyNames;
                updatedValues.manageableCompanies = this.companies.filter((item) => selectedItems.includes(item.name));
                this.modalRef.close(updatedValues);
            }
        } catch (e) {
            console.error('Updating item failed: ', e);
            this.trackingService.exception(e);
        }
    }
}
